/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Table_Ingested_ByInputs */

const es_settings_files_table_ingested_by = /** @type {(inputs: Settings_Files_Table_Ingested_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingerido por`)
};

const en_settings_files_table_ingested_by = /** @type {(inputs: Settings_Files_Table_Ingested_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingested by`)
};

/**
* | output |
* | --- |
* | "Ingested by" |
*
* @param {Settings_Files_Table_Ingested_ByInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_table_ingested_by = /** @type {((inputs?: Settings_Files_Table_Ingested_ByInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Table_Ingested_ByInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_table_ingested_by(inputs)
	return en_settings_files_table_ingested_by(inputs)
});
export { settings_files_table_ingested_by as "settings.files.table.ingested_by" }